import React, { useEffect, useState } from 'react';
import Personnummer from 'personnummer';
import { useNavigate } from 'react-router-dom';
import { Flex, Input, Button, Link, Label } from '@gjensidige/builders-components';

import { PRODUCTS } from '../lib/constants/appConstants';
import './PriceCalculationContainer.scss';
import carImage from '../images/Van.svg';
import { ageResolver } from '../services/CustomerService';
import { RoutingHelper } from '../utils/RoutingHelper';

const PriceCalculationContainer: React.FC = () => {
  const [registrationNumber, setRegistrationNumber] = useState('');
  const [personNumber, setPersonNumber] = useState('');
  const [enableButton, setEnableButton] = useState(false);
  const [validRegNumber, isValidRegNo] = useState(false);
  const [validPersonNumber, isValidPersonNumber] = useState(false);
  const navigate = useNavigate();

  const handleOnChangePersonNumber = (event: any) => {
    event.preventDefault();
    const customerInput = event.currentTarget.value.trim();
    setPersonNumber(customerInput.toUpperCase());
    const validPersonNumber = cprAndAgeValidator({ age: 18 }, customerInput);
    isValidPersonNumber(validPersonNumber);
  };
  const handleOnChangeRegNo = (event: any) => {
    event.preventDefault();
    const customerInput = event.currentTarget.value.trim().toUpperCase();
    const validRegNumber = new RegExp(/([A-Z]{3})([0-9]{2})([0-9A-Z])/).test(
      customerInput
    );
    const finalValidRegNumber = customerInput.length === 6 && validRegNumber;
    setRegistrationNumber(customerInput.toUpperCase());
    isValidRegNo(finalValidRegNumber);
  };

  const MIN_YEAR_PREFIX = 19;

  const cprAndAgeValidator = (options: any, inputValue: any) => {
    if (
      (inputValue.length !== 10 && inputValue.length !== 12) ||
      (inputValue.length === 12 &&
        Number(inputValue.slice(0, 2)) < MIN_YEAR_PREFIX) ||
      !Personnummer.valid(inputValue)
    ) {
      return false;
    } else {
      if (ageResolver(inputValue) < options.age) {
        return false;
      } else return true;
    }
  };

  useEffect(() => {
    setEnableButton(validRegNumber && validPersonNumber);
  }, [validRegNumber, validPersonNumber]);

  const gotoNextStep = () => {
    const customerInfo = {
      cprNumber: personNumber,
      registrationNumber: registrationNumber
    };
    sessionStorage.removeItem('policyDetails');
    sessionStorage.setItem('customerInfo', JSON.stringify(customerInfo));
    const nextPageUrlPath = RoutingHelper.resolveNextPageUrlPath(PRODUCTS.CAR);
    if (nextPageUrlPath) {
      navigate(nextPageUrlPath);
    }
  };
  const isDisabled = () => {
    return !enableButton;
  };
  return (
    <>
          <div className="calculate-step-header-div">
                <Flex center gap="lg" direction="column" align="center">
                  <div>
                    <img src={carImage} alt="Car Imgae" />
                  </div>
                  <div className="calculate-step-header-text">
                    Bilförsäkring
                  </div>

                  <div className="calculate-step-header-detail-text">
                    Oavsett vilken bilmodell du har, har vi bilforsäkringen.
                    Räkna ut ditt pris nedan och välj den forsäkring som passar
                    dig.
                  </div>
                </Flex>
               
          </div>
          <div className="mt-3 mb-2">
            <span className="container-detail-header-text">
              {' '}
              Se ditt pris och köp din bilförsäkring{' '}
            </span>
          </div>
          <Label htmlFor="input-registrationNumber">Bilens registreringsnummer</Label>
          <Input
            id="input-registrationNumber"
            name="input-registrationNumber"
            className="input-text-search"
            tracking={{
              eventAction: 'change',
              eventCategory: 'input-registrationNumber',
              eventKey: 'input-registrationNumber',
              eventLabel: '',
              eventModule: undefined,
              eventSource: 'PACKAGE_NAME',
              eventVersion: 'VERSION_NUMBER'
            }}
            value={registrationNumber}
            placeholder="ABC123"
            required={true}
            onChange={handleOnChangeRegNo}
          />
          <Label htmlFor="inputText-personNumber">Ditt personnummer</Label>
          <Input
            id="inputText-personNumber"
            name="inputText-personNumber"
            value={personNumber}
            placeholder="ÅÅÅÅMMDDNNNN"
            className="input-text-search"
            type="text"
            onChange={handleOnChangePersonNumber}
            required={true}
            //labelClassName="input-label-text"
            tracking={{
              eventAction: 'change',
              eventCategory: 'input_text',
              eventKey: 'input_text',
              eventLabel: '',
              eventModule: undefined,
              eventSource: 'PACKAGE_NAME',
              eventVersion: 'VERSION_NUMBER'
            }}
          />
          <Link href="#">
            Why do we ask about SSN?
          </Link>
          <Button
            variant="primary"
            fill
            onClick={gotoNextStep}
            disabled={isDisabled()}
            className="next-radio-button"
            size="md"
            tracking={{
              eventAction: 'click',
              eventCategory: 'critical_button',
              eventKey: 'critical_button',
              eventLabel: '',
              eventModule: undefined,
              eventSource: 'PACKAGE_NAME',
              eventVersion: 'VERSION_NUMBER'
            }}
            type="button"
          >
            Se ditt pris
          </Button>
          <div className="first-page-terms-condition pt-1">
            <a
              href="https://www.testgjensidige.se/forsakring/cookies-och-sakerhet/hantering-av-personuppgifter"
              target="_link1"
            >
              Läs om hur vi behandlar dina personuppgifter
            </a>
          </div>
    </>
  );
};
export default PriceCalculationContainer;
